<template>
  <div class="account-menu">
    <div class="text-center menu">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="gray"
            dark
            v-on="on"
            data-testid="account-menu-open-btn"
          >
            <v-icon>$avatar</v-icon>
            {{ user.firstName }}
            {{ user.lastName }}
          </v-btn>
        </template>
        <v-list class="pb-0">
          <v-list-item
            two-line
            class="pt-0 pb-2"
            style="min-height: 0px !important"
          >
            <v-list-item-content class="pt-0 pb-0">
              <v-list-item-title
                class="font-weight-black"
                style="font-size: 14px"
              >
                {{ user.firstName }} {{ user.lastName }}</v-list-item-title
              >
              <v-list-item-subtitle style="font-size: 14px" class="pt-1">{{
                user.companyName
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :to="{ name: 'Profile' }"
            data-testid="my-account-profile-btn"
            style="min-height: 32px !important; background-color: #272727"
            class="pl-1"
            date-testid="customer-admin-account-btn"
          >
            <v-list-item-title
              class="font-weight-medium"
              style="font-size: 14px"
            >
              <v-icon small class="mr-2 mb-1 ml-1">$user</v-icon>
              {{ $t('userProfile.myAccount') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'Help' }"
            data-testid="my-account-help-btn"
            style="min-height: 32px !important; background-color: #272727"
            class="pl-1"
          >
            <v-list-item-title class="font-weight-bold" style="font-size: 14px">
              <v-icon class="mr-1 ml-1" size="18">$helpIcon</v-icon>
              {{ $t('help.help') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="logoutClick"
            style="min-height: 32px !important; background-color: #272727"
            class="pl-1"
            data-testid="my-account-logout-btn"
          >
            <v-list-item-title
              class="font-weight-bold"
              style="font-size: 14px; color: #e20039"
            >
              <v-icon class="mr-1">$logout</v-icon>
              {{ $t('global.logout') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { MY_ACCOUNT_LOGOUT_CLICKED } from '@/constants/mixpanelEvents'

export default defineComponent({
  name: 'AccountMenu',
  data() {
    return {}
  },
  computed: {
    ...mapState('Security', ['user']),
  },
  methods: {
    ...mapActions('Security', ['test', 'logout']),
    async logoutClick() {
      this.$mixpanelUserTrack(MY_ACCOUNT_LOGOUT_CLICKED)
      await this.logout()
      this.$router.push('/logout')
    },
    menuClick() {
      this.test()
    },
  },
})
</script>

<style lang="scss">
.account-menu {
  @media only screen and (max-width: 600px) {
    .v-btn:not(.v-btn--round).v-size--default {
      padding: 0px 2px !important;
    }
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  .v-btn {
    border-radius: 2px;
  }

  .menu {
    .v-btn {
      font-weight: 400;
      svg {
        margin-right: 8px;
      }
    }
  }
}
</style>
